/** PURE_IMPORTS_START .._.._Observable,.._.._operator_delay PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { delay } from '../../operator/delay';
Observable.prototype.delay = delay;
//# sourceMappingURL=delay.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/delay.js
// module id = 659
// module chunks = 0